import axios from "axios";

const api = axios.create({});

export const getCountries = async () => {
  const response = await api.get('https://restcountries.com/v3.1/all?fields=name,capital,population,flags,subregion,continents,code');
  return response.data.map((country: any) => ({
    code: country.cca2 || '', // Country code (e.g., "NG")
    name: country.name.common || '', // Country name
    flag: country.flags?.svg || '', // SVG flag URL
    dial_code: country.idd?.root
      ? `${country.idd.root}${country.idd.suffixes?.[0] || ''}`
      : '',
    continent: country.continents?.[0] || '', // Continent
    region: country.region || '', // Region (e.g., Africa, Asia)
    subregion: country.subregion || '' // Subregion (e.g., Nigeria, Ghana)
  }));
};